import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Col, Icon, Menu, message, Radio, Row } from "antd";
import UploadModal from "components/UploadModal";
import {
    downloadExamPaperTemplate,
    ExamListItem,
    importExamFromExcel,
    saveExamPaperByManual
} from "service/exam";
import { errorMessage, isTrue } from "service/service";
import useModalHandler from "utils/useModalHandler";
import useModalHandlerV2 from "utils/v2/useModalHandler";
import LoadingModal from "../LoadingModal";
import { ResultMessage } from "components/ResultMessage";
import RandomAnswer from "./components/RandomAnswer";
import ChooseAnswer from "../../../../../answerStore/MyStore/components/SelectModal/ChooseAnswer";
import { QuestionListItem } from "../../../../../../service/answerStore";
import useRequestFn from "../../../../../../utils/useRequestFn";

interface MenuListProps extends ExamListItem {
    onAdd: () => void; //添加试卷方法
    handleMenuClick: () => void; //关闭menu方法
    handelResultVisible: () => void; //打开结果页面
}

export default function MenuList(props: MenuListProps) {
    const { onAdd, handleMenuClick, examId, handelResultVisible } = props;
    const uploadExcelModal = useModalHandler();
    const randomAnswerModal = useModalHandler();
    const chooseAnswerModal = useModalHandlerV2(ChooseAnswer, { remove: true });
    const [loading, setLoading] = useState(false);

    const onUploadOk = async (file?: File) => {
        if (!file) return;
        uploadExcelModal.close(); //批量导入弹窗关闭
        setLoading(true);

        try {
            await importExamFromExcel(file, examId);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        } finally {
            setLoading(false);
            handelResultVisible();
        }
    };

    const onPlay = () => {
        window.open(
            "http://go.plvideo.cn/front/video/view?vid=5c0ad4c56cb1e4889d1757e58ebacced_5"
        );
    };

    const tips = (
        <div className={style.tip}>
            使用说明：
            <br />
            1.仅支持导入的题型：单选题、多选题、填空题、判断题，不支持导入一个大标题下有多个小问题的题目。
            <br />
            2.不支持导入图片/音视频/公式。
        </div>
    );

    const [savaData] = useRequestFn(saveExamPaperByManual);
    async function saveToExam(data: QuestionListItem[]) {
        try {
            await savaData({
                examId,
                data: data.map(item => {
                    return {
                        questionId: item.questionId,
                        score: item.scope || 0
                    };
                })
            });
            message.success("选题成功");
            chooseAnswerModal.close();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            <Menu onClick={handleMenuClick}>
                <Menu.Item
                    key="1"
                    onClick={onAdd}
                    disabled={isTrue(props.isInvigilator)}>
                    手动出题
                </Menu.Item>
                <Menu.Item
                    key="2"
                    onClick={uploadExcelModal.open}
                    disabled={isTrue(props.isInvigilator)}>
                    Excel导入
                </Menu.Item>
                <Menu.Item
                    key="3"
                    onClick={randomAnswerModal.open}
                    disabled={isTrue(props.isInvigilator)}>
                    随机组卷
                </Menu.Item>
                <Menu.Item
                    key="4"
                    onClick={chooseAnswerModal.open}
                    disabled={isTrue(props.isInvigilator)}>
                    题库选题
                </Menu.Item>
            </Menu>

            {uploadExcelModal.render(
                <UploadModal
                    onUploadOk={onUploadOk}
                    onCancel={uploadExcelModal.close}
                    tips={tips}
                    title="Excel导入考核">
                    <Row className={style.row}>
                        <Col span={22} className={style.label}>
                            1.
                            <Button
                                className={style.link}
                                type="link"
                                onClick={downloadExamPaperTemplate}>
                                点击下载
                            </Button>
                            《导入考核模板》
                            <span className={style.tipLink} onClick={onPlay}>
                                <Icon type="play-square" />
                                点击查看使用说明视频
                            </span>
                        </Col>
                    </Row>
                    <Row className={style.row}>
                        <Col span={22} className={style.label}>
                            2.请选择本次导入模式：
                            <Radio value="0" checked>
                                直接导入
                            </Radio>
                        </Col>
                    </Row>
                    <Row className={style.row}>
                        <Col span={22} className={style.label}>
                            <i className={style.required}>*</i>
                            3.在导入模板补充好数据后上传文件
                        </Col>
                    </Row>
                </UploadModal>
            )}

            {randomAnswerModal.render(
                <RandomAnswer
                    visible={randomAnswerModal.visible}
                    onCancel={randomAnswerModal.close}
                    examId={examId}
                />
            )}
            {chooseAnswerModal.render(
                <ChooseAnswer
                    onConfirm={saveToExam}
                    onCancel={randomAnswerModal.close}
                />
            )}

            <LoadingModal
                visible={loading}
                onCancel={() => setLoading(false)}
            />
        </div>
    );
}
